import { __assign } from "tslib";
import * as React from "react";
import cx from "classnames";
import { spacingToPixels } from "./spacing";
import "./Stack.css";
var StackContext = React.createContext({ direction: "column" });
export var useStackContext = function () { return React.useContext(StackContext); };
export function Stack(_a) {
    var _b;
    var _c = _a.direction, direction = _c === void 0 ? "column" : _c, _d = _a.alignment, alignment = _d === void 0 ? "start" : _d, _e = _a.spacing, spacing = _e === void 0 ? "l" : _e, children = _a.children, _f = _a.padding, padding = _f === void 0 ? "none" : _f, _g = _a.style, style = _g === void 0 ? {} : _g, className = _a.className;
    var alignItems = {
        start: "flex-start",
        end: "flex-end",
        center: "center",
        stretch: "stretch"
    }[alignment];
    return (React.createElement(StackContext.Provider, { value: { direction: direction } },
        React.createElement("div", { className: cx("lluiStack", (_b = {},
                _b["lluiStack--row-" + spacing] = direction === "row",
                _b["lluiStack--column-" + spacing] = direction === "column",
                _b), className), style: __assign({ flexDirection: direction, alignItems: alignItems, height: direction === "column" ? "100%" : undefined, width: direction === "row" ? "100%" : undefined, padding: spacingToPixels(padding) + "px" }, style) }, children)));
}
export var HStack = function (props) { return (React.createElement(Stack, __assign({ direction: "row", alignment: "center" }, props))); };
export var VStack = function (props) { return React.createElement(Stack, __assign({ direction: "column" }, props)); };
